import { toLiteral } from "../../../helper/locale-utils";

export const DEFAULT_LITERAL_LANGUAGE = "en-US";

export enum TranslationStatus {
  all = "all",
  translated = "translated",
  nonTranslated = "non-translated",
}

interface TranslationStatusOptions {
  value: TranslationStatus;
  label: string;
}

export const GlobalLiteralStatsColumns = [
  { columnKey: "language", title: "administrator.language" },
  { columnKey: "tenantInUse", title: "home.literals.management.tenantsInUse" },
  { columnKey: "translationProgress", title: "home.literals.management.translationProgress" },
];

export const searchTypeOptions: TranslationStatusOptions[] = [
  { value: TranslationStatus.all, label: toLiteral({ id: "home.literals.management.translation.option.all" }) },
  { value: TranslationStatus.translated, label: toLiteral({ id: "home.literals.management.translation.option.translated" }) },
  { value: TranslationStatus.nonTranslated, label: toLiteral({ id: "admin.settings.literal.management.using.default" }) },
];

export const literalsToSkip = [
  "sidebar.home",
  "sidebar.recruitment",
  "sidebar.sourcing",
  "sidebar.sourcing.2",
  "sidebar.job.posting",
  "Leads Management",
  "sidebar.admin.settings",
  "tenant.configuration",
  "sidebar.configuration",
  "admin.manage.tenant.branch",
  "admin.tools",
  "sidebar.literals",
  "administrator.user.role.globalAdmin",
  "administrator.user.role.tenantAdmin",
  "Notifications",
  "Empty notifications",
  "",
  "literals.profile",
  "breadcrumb.calendars",
  "administrator.services.process.video.library",
  "home.literals.management.translation.option.all",
  "home.literals.management.translation.option.translated",
  "admin.manages.literals.value",
  "Literal value",
  "context.configuration.title",
  "context.configuration.TENANT",
  "Select tenant",
  "context.configuration.BRANCH",
  "context.configuration.PROFILE",
  "Select Profile",
  "CANCEL",
  "context.configuration.save",
  "Seleccionar delegación",
  "admin.settings.literal.management.using.default2",
  "home.literals.management.modal.title.viewLiteral2",
  "admin.literal.management.countryLiteral.translation.message.3",
  "home.search",
  "admin.manages.literals.value",
  "home.literals.management.modal.title.editTranslation2",
  "admin.literal.management.default.literal.heading2",
  "home.literals.management.addLiteral.value2",
  "admin.settings.literal.management.translated.status2",
  "admin.settings.literal.management.using.custom2",
  "admin.settings.literal.management.action.translate2",
  "admin.settings.literal.management.action.customize2",
  "admin.settings.literal.management.action.delete2",
  "admin.settings.literal.management.action.edit2",
];
